import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

axios.defaults.timeout = 30000

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}api`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const ticket3CheckinApi = {
  postCheckin: (request) => {
    const { data } = request
    // {
    //     "admin_id": "zwizfluke"
    // }
    const url = `/ticket/v3/cms/admin/user/check-in`
    return instance().post(url, data)
  },
  postCheckout: (request) => {
    const { data } = request
    // {
    //     "admin_id": "zwizticket_v3_01"
    // }
    const url = `/ticket/v3/cms/admin/user/check-out`
    return instance().post(url, data)
  },
  getValidateCheckout: () => {
    const url = `/ticket/v3/cms/admin/user/validate-checkout`
    return instance().get(url)
  },
  postForceCheckout: (request) => {
    const { data } = request
    const url = `/ticket/v3/cms/admin/user/force-check-out`
    return instance().post(url, data)
  }
}

export default ticket3CheckinApi



// WEBPACK FOOTER //
// ./src/api/ticket3/checkin.js